const config = {
    // backendApi: "http://192.168.1.8:6900/api/agent",
    // backendApi: "https://mshanag.tk4m.com/api/agent",
    backendApi: "https://mshanag.kl36.bet/api",
    color: {
        textColor: "#BECBE4",
        secondaryColor: "#E83E8C",
        red: "#f73232",
        green: "#16cc16",
        yellow: "#f4f439",
        violet: 'violet'
    }
};

export default config;
